import type { TpOrderMeta, TpSellOrder } from './types';

export const TP_ORDER: Record<TpSellOrder, TpOrderMeta> = {
  lead: {
    label: 'Lead with',
    color: 'var(--success)',
    tint: 'var(--success-tint)',
    icon: 'bolt',
  },
  then: {
    label: 'Then',
    color: 'var(--gold)',
    tint: 'var(--gold-tint)',
    icon: 'arrow-r',
  },
  last: {
    label: 'Save for last',
    color: 'var(--terracotta)',
    tint: 'var(--terracotta-tint)',
    icon: 'stopwatch',
  },
};
